import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

import { tokenConfig } from '../../utils/apiConfig'
import LocationPicker from '../LocationPicker'
import { buildLocationUrl, locationLabel } from '../../utils/locationLink'

const UpdateEvent = (props) => {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [status, setStatus] = useState('')
    const [locationName, setLocationName] = useState('')
    const [locationPlaceId, setLocationPlaceId] = useState('')
    const [editingLocation, setEditingLocation] = useState(false)
    const [difficulty, setDifficulty] = useState('')
    const [capacity, setCapacity] = useState('')

    useEffect(() => {
        if (props._id) {
            const event = props.events.find(({ _id }) => _id === props._id)
            setName(event.name)
            setDescription(event.description)
            setStatus(event.status)
            setLocationName(event.location || '')
            setLocationPlaceId(event.locationPlaceId || '')
            setEditingLocation(false)
            setDifficulty(event.difficulty)
            setCapacity(event.capacity)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props._id])

    const updateEvent = async e => {
        e.preventDefault()
        const updatedEvent = {
            _id: props._id, name, description, status,
            location: locationName, locationPlaceId,
            capacity, difficulty,
            company_id: "5f44f153841c2929c2eee625"
        }
        await axios.patch('/api/events', updatedEvent, tokenConfig())
            .then(res => {
                props.toggle(false)
                const updatedEvents = props.events.map(event => {
                    if (event._id === res.data._id) return res.data
                    return event
                })
                props.insertUpdatedEvent(updatedEvents)
            })
            .catch(err => console.log(err.message))
    }

    return (
        <Modal isOpen={props.updateEvent} size='lg' toggle={() => props.toggle(false)}>
            <ModalHeader toggle={() => props.toggle(false)}>Update Event</ModalHeader>
            <Form onSubmit={updateEvent}>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Event Name</Label>
                                <Input type="text" defaultValue={name} onChange={e => setName(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Description</Label>
                                <Input type="textarea" defaultValue={description} onChange={e => setDescription(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Difficulty</Label>
                                <Input type="select" defaultValue={difficulty} onChange={e => setDifficulty(e.target.value)} required>
                                    <option>Beginner</option>
                                    <option>Intermediate</option>
                                    <option>Hard</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Status</Label>
                                <Input type="select" defaultValue={status} onChange={e => setStatus(e.target.value)} required>
                                    <option>Open</option>
                                    <option>Closed</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Location</Label>
                                {!editingLocation ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minHeight: '38px' }}>
                                        {locationName ? (
                                            <a href={buildLocationUrl(locationName, locationPlaceId)} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.9rem' }}>
                                                {locationLabel(locationName)}
                                            </a>
                                        ) : (
                                            <span className="text-muted" style={{ fontSize: '0.9rem' }}>No location set</span>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-link btn-sm p-0"
                                            title="Edit location"
                                            onClick={() => setEditingLocation(true)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                    </div>
                                ) : (
                                    <LocationPicker
                                        value={locationName}
                                        onChange={({ name, placeId }) => {
                                            setLocationName(name)
                                            setLocationPlaceId(placeId)
                                            setEditingLocation(false)
                                        }}
                                    />
                                )}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Capacity</Label>
                                <Input type="number" defaultValue={capacity} onChange={e => setCapacity(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button type='submit' color="primary">Update</Button>{' '}
                    <Button color="secondary" onClick={() => props.toggle(false)}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default UpdateEvent;
